import { Button, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../components/spinner/Spinner';

const Verification = ({ verificationDetails }) => {
    const styledContainer = {
        bgcolor: '#fbfaff',
        boxShadow: '0px 6px 22px rgba(0, 0, 0, 0.08)',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        gap:3,
        flexDirection: 'column',
        m: 2,
        p: 4,
    };
    const buttonCss = {
        alignSelf: 'center',
    };
    const spinnerCss = {
        ml: 3,
        position: 'relative',
        bottom: -10,
    };
    const navigate = useNavigate();

    return (
        <Paper sx={styledContainer}>
            <Typography component='div' align='center' variant='h5'>
                {verificationDetails ? (
                    verificationDetails?.message
                ) : (
                    <Box sx={{ ml: 3 }}>
                        {'Verifying'} <Spinner sx={spinnerCss} />
                    </Box>
                )}
            </Typography>

            <Button
                sx={buttonCss}
                variant='contained'
                color='primary'
                size='large'
                onClick={() => navigate('/login')}>
                Go to Login
            </Button>
        </Paper>
    );
};

export default Verification;
